import React from 'react';
import { Circle, ArrowRight } from 'lucide-react';
import { products, images } from '../data/mock';

const ProductsSection = ({ onRequestQuote }) => {
  return (
    <section id="products" className="section-padding" style={{ background: 'var(--bg-secondary)' }}>
      <div className="container">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start mb-16">
          <div>
            <div className="section-header" style={{ marginBottom: 0 }}>
              <p className="section-label">Our Products</p>
              <h2 className="section-title">Comprehensive Fastening Solutions</h2>
              <p className="section-description">
                An extensive catalog of precision-engineered fasteners designed to meet 
                the demanding requirements of modern manufacturing.
              </p>
            </div>
            <button 
              className="btn-text mt-6"
              onClick={onRequestQuote}
            >
              Need help choosing?
              <ArrowRight size={14} />
            </button>
          </div>
          <div className="image-overlay-container hidden lg:block" style={{ height: '300px' }}>
            <img 
              src={images.products}
              alt={images.productsAlt}
              className="img-cover"
              loading="lazy"
            />
            <div className="image-overlay" />
          </div>
        </div>

        <div className="product-grid">
          {products.map((product, index) => (
            <div key={index} className="product-card">
              {product.image ? (
                <div className="product-image-container">
                  <img 
                    src={product.image} 
                    alt={product.name}
                    className="product-image"
                    loading="lazy"
                  />
                </div>
              ) : (
                <Circle className="product-icon" strokeWidth={1} />
              )}
              <h3 className="product-name">{product.name}</h3>
              <p className="product-category">{product.category}</p>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <button className="btn-secondary" onClick={onRequestQuote}>
            Request Custom Quote
            <ArrowRight size={14} />
          </button>
        </div>
      </div>
    </section>
  );
};

export default ProductsSection;
